<template>
  <div>
    <v-checkbox v-model="isCreation"
                :label="switchLabel(isCreation)"
                color="valid"
    />
    <template v-if="!isCreation">
      <v-radio-group v-model="control.value"
                     @change="onEditControl('value', $event)"
      >
        <v-text-field
          v-model="search"
          append-icon="search"
          :label="$t('components.searchPlaceholder')"
          single-line
          hide-details
          color="valid"
        />
        <question-edit-panel-table :loading-question-terminate="loadingQuestionOpen"
                                   :questions-props="availableOpens"
                                   :search="search"
        />
      </v-radio-group>
    </template>
    <template v-else>
      <form-open :is-clone="false"
                 :is-modification="false"
                 :just-save="true"
                 @save="save"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormOpen from '@/components/questions/formOpen'
import panelMixin from '@/components/questionnaires/fields/editPanels/panelMixin'
import questionPanelMixin from '@/components/questionnaires/fields/editPanels/questionPanelMixin'
import QuestionEditPanelTable
  from '@/components/questionnaires/fields/editPanels/QuestionEditPanelTable/QuestionEditPanelTable'

export default {
  name: 'OpenQuestionEditPanel',
  mixins: [panelMixin, questionPanelMixin],
  components: {
    FormOpen,
    QuestionEditPanelTable
  },
  data () {
    return {
      loadingQuestionOpen: true,
      search: ''
    }
  },
  computed: {
    ...mapGetters('Questions', [
      'questionOpen',
      'questionsOpen'
    ]),
    ...mapGetters('Questionnaires', [
      'usedQuestionIds'
    ]),
    availableOpens () {
      return this.questionsOpen.filter(
        question => question.id === this.control.value || !this.usedQuestionIds.includes(question.id)
      )
    }
  },
  async created () {
    this.loadingQuestionOpen = false
  },
  methods: {
    ...mapActions('Questions', [
      'createQuestion'
    ]),
    switchLabel (isCreation) {
      return isCreation
        ? this.$t('components.questionnaires.panels.creation')
        : this.$t('components.questionnaires.panels.selection')
    },
    async save (payload) {
      await this.createQuestion(
        {
          question: payload.question,
          saveType: 'saveQuestionnaire'
        }
      )
      this.control.value = this.questionOpen.id
      this.isCreation = false
    }
  }
}
</script>
